import { isUndefined } from "lodash";

import type { DownloadAsset } from "../types/common";

export const isWorkbenchActionDisabled = (
    isCompliant: boolean | undefined,
    previewAsset: DownloadAsset | undefined,
    downloadAsset: DownloadAsset | undefined,
    outputFileFormats?: string[],
): boolean => {
    return (
        !isCompliant ||
        isUndefined(previewAsset) ||
        isUndefined(downloadAsset) ||
        !!outputFileFormats?.includes("zip")
    );
};
